// Timers a background tab does not slow down (60.11.579). Chrome runs a hidden tab's own timers at most once a minute
// after five minutes, longer than the CRM waits (30 s) before it counts a screen share as gone; a worker's timers keep
// their time. The page's own timer stays behind each one, a little later, in case the worker never answers; without
// workers (old browsers, tests) the page's own timer alone serves.

const WORKER_SOURCE =
  'var t={};onmessage=function(e){var d=e.data;clearTimeout(t[d.id]);delete t[d.id];' +
  'if(d.ms>=0)t[d.id]=setTimeout(function(){delete t[d.id];postMessage(d.id)},d.ms)}'

/** How much later the page's own timer runs what the worker has not. */
export const STEADY_BACKSTOP_MS = 2000

let worker: Worker | null | undefined
const waiting = new Map<number, () => void>()
let lastId = 0

const tickWorker = () => {
  if (worker !== undefined) return worker
  worker = null
  if (
    typeof window.Worker === 'undefined' ||
    typeof Blob === 'undefined' ||
    typeof URL.createObjectURL !== 'function'
  )
    return worker
  try {
    const created = new window.Worker(
      URL.createObjectURL(new Blob([WORKER_SOURCE], {type: 'text/javascript'}))
    )
    created.onmessage = (event: MessageEvent<number>) => waiting.get(event.data)?.()
    worker = created
  } catch {
    worker = null
  }
  return worker
}

/** Runs `run` once, after `ms`; the function it answers cancels it. */
export const steadyTimeout = (run: () => void, ms: number): (() => void) => {
  const ticker = tickWorker()
  if (!ticker) {
    const timer = window.setTimeout(run, ms)
    return () => window.clearTimeout(timer)
  }
  const id = ++lastId
  let backstop = 0
  const cancel = () => {
    if (!waiting.delete(id)) return
    window.clearTimeout(backstop)
    ticker.postMessage({id, ms: -1})
  }
  waiting.set(id, () => {
    cancel()
    run()
  })
  backstop = window.setTimeout(() => waiting.get(id)?.(), ms + STEADY_BACKSTOP_MS)
  ticker.postMessage({id, ms})
  return cancel
}
